import { render, staticRenderFns } from "./CuratorsIndex.vue?vue&type=template&id=0e71b26f"
import script from "./CuratorsIndex.vue?vue&type=script&lang=js"
export * from "./CuratorsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports